export default __webpack_public_path__ + "static/supermaxonline-d3e8c36a2209d2e2f59bfc80270fe936.png";